<!-- Overlay de Loading -->
<div class="loading-overlay" *ngIf="uploading">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Enviando documento...</p>
</div>

<div class="container">

  <!-- Dados do Militar -->
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiary.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiary.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiary.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiary.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiary.orgao.sigla }}</span>
    </div>
  </mat-card>

  <!-- Dados do Requerimento -->
  <mat-card class="requerimento-fields">
    <h2>Dados do Requerimento</h2>
    <div class="fields-row">
      <mat-form-field appearance="outline">
        <mat-label>Data do Requerimento</mat-label>
        <input matInput type="date" [(ngModel)]="dataRequerimento">
      </mat-form-field>

      <mat-form-field appearance="outline" class="observacao-field">
        <mat-label>Observação</mat-label>
        <input matInput [(ngModel)]="observacao" placeholder="Ex: solicitando reserva">
      </mat-form-field>
    </div>
  </mat-card>

  <!-- Título da seção -->
  <h3 class="section-title">INATIVIDADE</h3>

  <!-- Cards -->
  <div class="cards-grid">
    <!-- Voluntária -->
    <mat-card class="apo-card">
      <h4>Reserva remunerada - a pedido</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reserva remunerada - a pedido')">
          <mat-icon>download</mat-icon>
        </button>
        <!-- Botão de upload -->
        <button mat-icon-button matTooltip="Enviar documento" (click)="abrirFilePicker('Reserva')">
          <mat-icon>upload</mat-icon>
        </button>

        <!-- Input de arquivo oculto -->
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" hidden />
      </div>
      <p>Anexe o requerimento.</p>
    </mat-card>

    <!-- Deficiência -->
    <mat-card class="apo-card">
      <h4>Reserva remunerada - ex Officio</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reserva remunerada - ex officio')">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Enviar documento" (click)="abrirFilePicker('Reserva')">
          <mat-icon>upload</mat-icon>
        </button>
      </div>
      <p>Anexe o requerimento.</p>
    </mat-card>

    <!-- Decisão Judicial -->
    <mat-card class="apo-card">
      <h4>Reforma por incapacidade</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reforma por incapacidade')">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Enviar documento" (click)="abrirFilePicker('Laudo')">
          <mat-icon>upload</mat-icon>
        </button>
      </div>
      <p>Anexe o laudo medico.</p>
    </mat-card>
  </div>

  <div class="cards-grid">
    <!-- Voluntária -->
    <mat-card class="apo-card">
      <h4>Reforma por idade</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reforma por idade')">
          <mat-icon>download</mat-icon>
        </button>
        <!-- Botão de upload -->
        <button mat-icon-button matTooltip="Enviar documento" (click)="abrirFilePicker('Reserva')">
          <mat-icon>upload</mat-icon>
        </button>

        <!-- Input de arquivo oculto -->
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" hidden />
      </div>
      <p>Anexe o requerimento.</p>
    </mat-card>

    <!-- Deficiência -->
    <mat-card class="apo-card">
      <h4>Reforma por tempo de contribuição</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reforma por tempo de contribuição')">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Enviar documento" (click)="abrirFilePicker('Requerimento')">
          <mat-icon>upload</mat-icon>
        </button>
      </div>
      <p>Anexe o requerimento.</p>
    </mat-card>

    <!-- Decisão Judicial -->

  </div>




</div>
